export default "__VITE_ASSET__BfX6_iQ9__"